var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7889 1.57771C12.0518 0.103611 9.94819 0.103612 9.21115 1.57771L0.447213 19.1056C-0.217688 20.4354 0.749304 22 2.23607 22H19.7639C21.2507 22 22.2177 20.4354 21.5528 19.1056L12.7889 1.57771ZM10.0771 7.24461C10.0771 6.73494 10.4903 6.32178 11 6.32178C11.5096 6.32178 11.9228 6.73495 11.9228 7.24463V9.49466L11.5191 13.4873C11.4921 13.7538 11.2678 13.9566 11 13.9566C10.7321 13.9566 10.5078 13.7538 10.4808 13.4873L10.0771 9.49466L10.0771 7.24461ZM10.0771 16.6313C10.0771 16.1217 10.4903 15.7085 11 15.7085C11.5097 15.7085 11.9228 16.1217 11.9228 16.6313V16.7735C11.9228 17.2831 11.5097 17.6963 11 17.6963C10.4903 17.6963 10.0771 17.2831 10.0771 16.7735V16.6313Z",
    fill: "#A13238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotification);
export default __webpack_public_path__ + "static/media/error-notification.466066c573153b702d7c535b7d5224bd.svg";
export { ForwardRef as ReactComponent };